import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useNotif } from '../context/NotifContext';
import Topbar from '../components/Topbar';
import './EmployeeDashboard.css';

const MY_TASKS = [
  {id:1,title:'Follow up with Rajesh Nair',due:'2026-05-29',priority:'High',status:'todo'},
  {id:2,title:'Prepare weekly report',due:'2026-05-30',priority:'Medium',status:'todo'},
  {id:3,title:'Update lead statuses in CRM',due:'2026-05-28',priority:'Urgent',status:'inprogress'},
  {id:4,title:'Send proposal to Vikram Nanda',due:'2026-06-01',priority:'High',status:'todo'},
  {id:5,title:'Client onboarding deck review',due:'2026-05-25',priority:'Low',status:'done'},
];

const ATTENDANCE_HISTORY = [
  {date:'2026-05-27',checkIn:'09:02',checkOut:'18:15',hours:'9h 13m',status:'Full Day'},
  {date:'2026-05-26',checkIn:'09:18',checkOut:'14:30',hours:'5h 12m',status:'Half Day'},
  {date:'2026-05-24',checkIn:'08:55',checkOut:'18:00',hours:'9h 05m',status:'Full Day'},
];

const LEAVE_BALANCE = [
  {type:'Casual Leave',total:12,used:3,left:9,color:'#3B82F6'},
  {type:'Sick Leave',total:8,used:1,left:7,color:'#22C55E'},
  {type:'Earned Leave',total:15,used:5,left:10,color:'#F5A623'},
];

const NAV_ITEMS = [
  {id:'dashboard',icon:'📊',label:'My Dashboard'},
  {id:'tasks',    icon:'✅',label:'My Tasks'},
  {id:'attendance',icon:'📅',label:'Attendance'},
  {id:'leave',    icon:'🌴',label:'Leave'},
  {id:'salary',   icon:'💰',label:'Salary'},
];

const PCOLOR = {Urgent:'#EF4444',High:'#F5A623',Medium:'#3B82F6',Low:'#6B7280'};
const today  = new Date().toISOString().split('T')[0];

export default function EmployeeDashboard() {
  const {theme}    = useTheme();
  const {user}     = useAuth();
  const navigate   = useNavigate();
  const [tab, setTab]             = useState('dashboard');
  const [tasks, setTasks]         = useState(MY_TASKS);
  const [checkedIn, setCheckedIn] = useState(false);
  const [checkInTime, setCheckInTime] = useState(null);
  const [showLeaveModal, setShowLeaveModal] = useState(false);

  const doneCount = tasks.filter(t=>t.status==='done').length;
  const overdueCount = tasks.filter(t=>t.due < today && t.status!=='done').length;
  const toggleDone = id => setTasks(ts=>ts.map(t=>t.id===id?{...t,status:t.status==='done'?'todo':'done'}:t));

  const handleCheckIn = () => {
    if (!checkedIn) { setCheckedIn(true); setCheckInTime(new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'})); }
    else { setCheckedIn(false); }
  };

  return (
    <div className="emp-wrap" data-theme={theme}>
      {/* Employee Sidebar */}
      <div className="emp-sb" data-theme={theme}>
        <div className="emp-sb-logo">R</div>
        <div className="emp-sb-version">v1.0.8</div>
        <div className="emp-sb-user">
          <div className="emp-sb-av">{user.initials}</div>
          <div>
            <div className="emp-sb-name">{user.name}</div>
            <div className="emp-sb-role">{user.role}</div>
          </div>
        </div>
        <div className="emp-sb-divider"/>
        {NAV_ITEMS.map(n=>(
          <div key={n.id} className={`emp-sb-item${tab===n.id?' active':''}`} onClick={()=>setTab(n.id)}>
            <span className="emp-sb-icon">{n.icon}</span>
            <span className="emp-sb-label">{n.label}</span>
          </div>
        ))}
        <div style={{flex:1}}/>
        <div className="emp-sb-item emp-sb-signout" onClick={()=>navigate('/login')}>
          <span className="emp-sb-icon">🚪</span>
          <span className="emp-sb-label">Sign Out</span>
        </div>
      </div>

      <div className="emp-main">
        <Topbar
          title={tab==='dashboard'?<>Good morning, <span>{user.name}</span> 👋</>:NAV_ITEMS.find(n=>n.id===tab)?.label}
          subtitle={tab==='dashboard'?`${user.dept} · ${user.role}`:''}
        />

        {/* Dashboard Tab */}
        {tab === 'dashboard' && (
          <div className="emp-content">
            <div className="emp-stat-row">
              {[
                {label:'Tasks assigned',val:tasks.length,color:'#3B82F6'},
                {label:'Completed',val:doneCount,color:'#22C55E'},
                {label:'Overdue',val:overdueCount,color:'#EF4444'},
                {label:'Leave balance',val:'9 days',color:'#F5A623'},
              ].map(s=>(
                <div key={s.label} className="emp-stat-card">
                  <div className="emp-stat-lbl">{s.label}</div>
                  <div className="emp-stat-val" style={{color:s.color}}>{s.val}</div>
                </div>
              ))}
            </div>

            <div className="emp-two-col">
              {/* Today's quick tasks */}
              <div className="emp-panel">
                <div className="emp-panel-hd">Today's tasks</div>
                {tasks.filter(t=>t.status!=='done').slice(0,4).map(t=>(
                  <div key={t.id} className="emp-task-row">
                    <div className="emp-task-check" onClick={()=>toggleDone(t.id)}>○</div>
                    <div className="emp-task-info">
                      <div className="emp-task-title">{t.title}</div>
                      <div className="emp-task-due">Due {t.due}</div>
                    </div>
                    <span className="emp-task-pri" style={{color:PCOLOR[t.priority],background:PCOLOR[t.priority]+'18'}}>{t.priority}</span>
                  </div>
                ))}
                <div className="emp-see-all" onClick={()=>setTab('tasks')}>See all tasks →</div>
              </div>

              {/* Quick attendance */}
              <div className="emp-panel">
                <div className="emp-panel-hd">Today's attendance</div>
                <div className="emp-att-today">
                  <div className="emp-att-date">{new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long'})}</div>
                  {checkedIn && <div className="emp-att-time-badge">Checked in at {checkInTime}</div>}
                  <div className={`emp-checkin-btn${checkedIn?' emp-checkout':''}`} onClick={handleCheckIn}>
                    {checkedIn ? '✓ Check Out' : 'Check In'}
                  </div>
                  <div className="emp-att-note">{checkedIn ? 'Have a productive day!' : '9AM–6PM = Full Day · 4h+ = Half Day'}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Tasks Tab */}
        {tab === 'tasks' && (
          <div className="emp-content">
            <div className="emp-panel emp-panel-full">
              <div className="emp-panel-hd">My Tasks <span className="emp-badge">{tasks.length}</span></div>
              {tasks.map(t=>(
                <div key={t.id} className={`emp-task-row${t.status==='done'?' done':''}`}>
                  <div className="emp-task-check" onClick={()=>toggleDone(t.id)}>{t.status==='done'?'✓':'○'}</div>
                  <div className="emp-task-info">
                    <div className="emp-task-title">{t.title}</div>
                    <div className="emp-task-due">Due {t.due} {t.due < today && t.status!=='done' ? '⚠ Overdue' : ''}</div>
                  </div>
                  <span className="emp-task-pri" style={{color:PCOLOR[t.priority],background:PCOLOR[t.priority]+'18'}}>{t.priority}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Attendance Tab */}
        {tab === 'attendance' && (
          <div className="emp-content">
            <div className="emp-panel emp-panel-full">
              <div className="emp-panel-hd">Today — Mark Attendance</div>
              <div className="emp-att-today">
                <div className="emp-att-date">{new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</div>
                {checkedIn && <div className="emp-att-time-badge">Checked in at {checkInTime}</div>}
                <div className={`emp-checkin-btn${checkedIn?' emp-checkout':''}`} onClick={handleCheckIn}>
                  {checkedIn ? '✓ Check Out' : '→ Check In'}
                </div>
                <div className="emp-att-note">9AM–6PM = Full Day · 4h+ = Half Day</div>
              </div>
            </div>
            <div className="emp-panel emp-panel-full">
              <div className="emp-panel-hd">Attendance History</div>
              <table className="emp-table">
                <thead><tr>{['Date','Check In','Check Out','Hours','Status'].map(h=><th key={h} className="emp-th">{h}</th>)}</tr></thead>
                <tbody>{ATTENDANCE_HISTORY.map(a=>(
                  <tr key={a.date} className="emp-tr">
                    <td className="emp-td">{a.date}</td>
                    <td className="emp-td" style={{color:'#F5A623'}}>{a.checkIn}</td>
                    <td className="emp-td" style={{color:'#22C55E'}}>{a.checkOut}</td>
                    <td className="emp-td">{a.hours}</td>
                    <td className="emp-td"><span className={`emp-status-pill${a.status==='Full Day'?' green':'  amber'}`}>{a.status}</span></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </div>
        )}

        {/* Leave Tab */}
        {tab === 'leave' && (
          <div className="emp-content">
            <div className="emp-leave-grid">
              {LEAVE_BALANCE.map(l=>(
                <div key={l.type} className="emp-leave-card">
                  <div className="emp-leave-type">{l.type}</div>
                  <div className="emp-leave-val" style={{color:l.color}}>{l.left}</div>
                  <div className="emp-leave-sub">days remaining</div>
                  <div className="emp-leave-bar-track">
                    <div className="emp-leave-bar-fill" style={{width:`${(l.left/l.total)*100}%`,background:l.color}}/>
                  </div>
                  <div className="emp-leave-meta">{l.used} used of {l.total}</div>
                </div>
              ))}
            </div>
            <div className="emp-panel emp-panel-full">
              <div className="emp-panel-hd" style={{justifyContent:'space-between'}}>
                Leave requests
                <div className="emp-apply-btn" onClick={()=>setShowLeaveModal(true)}>+ Apply Leave</div>
              </div>
              <div className="emp-empty-state">No leave requests yet</div>
            </div>
          </div>
        )}

        {/* Salary Tab */}
        {tab === 'salary' && (
          <div className="emp-content">
            <div className="emp-panel emp-panel-full">
              <div className="emp-panel-hd">Salary Details</div>
              <div className="emp-salary-info">
                <div className="emp-salary-row"><span>Monthly CTC</span><span>₹35,000</span></div>
                <div className="emp-salary-row"><span>Last paid</span><span className="green">₹35,000 on 1 May 2026</span></div>
                <div className="emp-salary-row"><span>Next payment</span><span>1 June 2026</span></div>
                <div className="emp-salary-row"><span>Payment mode</span><span>Bank Transfer</span></div>
              </div>
            </div>
          </div>
        )}
      </div>

      {showLeaveModal && (
        <div className="emp-modal-overlay" onClick={()=>setShowLeaveModal(false)}>
          <div className="emp-modal" data-theme={theme} onClick={e=>e.stopPropagation()}>
            <div className="emp-modal-hd"><span>Apply Leave</span><span className="emp-modal-close" onClick={()=>setShowLeaveModal(false)}>✕</span></div>
            <div className="emp-modal-body">
              <div className="emp-form-grp"><label className="emp-lbl">Leave type</label>
                <select className="emp-inp"><option>Casual Leave</option><option>Sick Leave</option><option>Earned Leave</option></select>
              </div>
              <div className="emp-form-grp"><label className="emp-lbl">From date</label><input className="emp-inp" type="date"/></div>
              <div className="emp-form-grp"><label className="emp-lbl">To date</label><input className="emp-inp" type="date"/></div>
              <div className="emp-form-grp"><label className="emp-lbl">Reason</label><textarea className="emp-inp emp-ta" rows={3} placeholder="Brief reason…"/></div>
            </div>
            <div className="emp-modal-ft">
              <div className="emp-btn-sec" onClick={()=>setShowLeaveModal(false)}>Cancel</div>
              <div className="emp-btn-pri" onClick={()=>setShowLeaveModal(false)}>Submit Request</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
